"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgHeart = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.993 3.717c-2.34-2.045-5.8-2.463-8.488-.167-2.907 2.483-3.329 6.666-1.03 9.624.872 1.123 2.575 2.81 4.212 4.354a185.309 185.309 0 0 0 4.138 3.775c.076.068.172.153.263.221.11.083.267.185.476.248.28.083.579.083.858 0 .21-.063.367-.165.476-.247.092-.07.187-.154.264-.222l.015-.014c.815-.721 2.467-2.198 4.123-3.76 1.636-1.545 3.34-3.232 4.212-4.355 2.29-2.946 1.932-7.161-1.041-9.633-2.717-2.258-6.141-1.87-8.478.176Z", fill: "currentColor" }) }))); };
exports.default = SvgHeart;
